/* eslint-disable no-console */
/* eslint-disable class-methods-use-this */
import { CameraType } from '@app/engine/camera/camera';
import { ToastMsgType } from '@app/engine/core/interfaces';
import { EventBus } from '@app/engine/events/event-bus';
import { EventBusEvent } from '@app/engine/events/event-bus-events';
import { errorManagerInstance } from '@app/engine/utils/errorManager';
import { keepTrackApi } from '@app/keepTrackApi';
import { SelectSatManager } from '../select-sat-manager/select-sat-manager';
export class GamepadPlugin {
    id = 'GamepadPlugin';
    dependencies_ = [];
    currentController = null;
    deadzone = 0.55;
    buttonsPressedHistory = [];
    buttonsPressed = [];
    previouslyReportedGamepads = [];
    init() {
        window.addEventListener('gamepadconnected', (e) => {
            if (settingsManager.cruncherReady) {
                this.initializeGamepad(e.gamepad);
            }
            else {
                EventBus.getInstance().once(EventBusEvent.uiManagerInit, () => this.initializeGamepad(e.gamepad));
            }
        });
        window.addEventListener('gamepaddisconnected', () => {
            keepTrackApi.getUiManager().toast('Gamepad disconnected', ToastMsgType.critical);
            this.currentController = null;
        });
    }
    initializeGamepad(gamepad) {
        keepTrackApi.getUiManager().toast('Gamepad connected', ToastMsgType.normal);
        // Only initialize once
        if (!this.currentController) {
            EventBus.getInstance().on(EventBusEvent.updateLoop, this.updateGamepad.bind(this));
        }
        this.currentController = gamepad;
    }
    updateGamepad(index) {
        index ??= 0; // Assume first gamepad if not specified
        const controller = GamepadPlugin.getController(index);
        if (controller === null) {
            return;
        } // No controller anymore - give up
        if (!this.validateController(controller)) {
            return;
        }
        this.currentController = controller;
        this.updateZoom_();
        this.updateLeftStick_();
        this.updateRightStick_();
        this.updateButtons_();
    }
    validateController(controller) {
        if (controller.buttons.length < 17) {
            // Check if this gamepad has already been reported
            if (!this.previouslyReportedGamepads.includes(controller.id)) {
                errorManagerInstance.warn('This gamepad is not supported. Please open an issue on GitHub with the gamepad model to get it added.');
                this.previouslyReportedGamepads.push(controller.id);
            }
            return false;
        }
        if (controller.axes.length < 4) {
            if (!this.previouslyReportedGamepads.includes(controller.id)) {
                errorManagerInstance.warn('This gamepad is not supported. Please open an issue on GitHub with the gamepad model to get it added.');
                this.previouslyReportedGamepads.push(controller.id);
            }
            return false;
        }
        return true;
    }
    updateButtons_() {
        if (!this.currentController) {
            return;
        }
        const buttons = this.currentController.buttons;
        buttons.forEach((button, index) => {
            // if the button is pressed and wasnt pressed before
            if (button.pressed && !this.buttonsPressed[index]) {
                // button state is now pressed
                this.buttonsPressed[index] = true;
                this.buttonsPressedHistory.push(index);
                // Maximum of 20 in the history
                if (this.buttonsPressedHistory.length > 8) {
                    this.buttonsPressedHistory.shift();
                }
                // Perform action
                switch (index) {
                    case 0:
                        this.btnA_();
                        break;
                    case 1:
                        this.btnB_();
                        break;
                    case 2:
                        this.btnX_();
                        break;
                    case 3:
                        this.btnY_();
                        break;
                    case 4:
                        this.btnLeftBumper();
                        break;
                    case 5:
                        this.btnRightBumper_();
                        break;
                    case 8:
                        this.btnHome_();
                        break;
                    case 9:
                        this.btnStart_();
                        break;
                    case 10:
                        this.btnLeftStick_();
                        break;
                    case 11:
                        this.btnRightStick_();
                        break;
                    case 12:
                        this.btnDpadUp_();
                        break;
                    case 13:
                        this.btnDpadDown_();
                        break;
                    case 14:
                        this.btnDpadLeft_();
                        break;
                    case 15:
                        this.btnDpadRight_();
                        break;
                    case 16:
                        this.btnXbox();
                        break;
                    default:
                        /*
                         * DEBUG:
                         * console.debug(`Button ${index}`);
                         */
                        break;
                }
                // if the button is not pressed and was pressed before
            }
            else if (!button.pressed && this.buttonsPressed[index]) {
                // button state is now not pressed
                this.buttonsPressed[index] = false;
            }
        });
    }
    btnA_() {
        if (settingsManager.isLimitedGamepadControls) {
            return;
        }
        console.log('A');
        keepTrackApi.getPlugin(SelectSatManager)?.selectSat(keepTrackApi.getHoverManager().hoveringSat);
    }
    btnB_() {
        if (settingsManager.isLimitedGamepadControls) {
            return;
        }
        console.log('B');
        keepTrackApi.getPlugin(SelectSatManager)?.selectSat(-1);
        keepTrackApi.getMainCamera().state.zoomTarget = 0.8;
    }
    btnX_() {
        if (settingsManager.isLimitedGamepadControls) {
            return;
        }
        console.log('X');
        keepTrackApi.getMainCamera().autoRotate();
    }
    btnY_() {
        console.log('Y');
        /*
         * if (settingsManager.colors.transparent[3] === 0.2) {
         *   settingsManager.colors.transparent = [1, 1, 1, 0];
         *   settingsManager.dotsPerColor = null;
         * } else {
         *   settingsManager.colors.transparent = [1, 1, 1, 0.2];
         *   settingsManager.dotsPerColor = 100;
         * }
         * uiManager?.keyHandler({ key: 'C' });
         */
    }
    btnLeftBumper() {
        if (settingsManager.isLimitedGamepadControls) {
            return;
        }
        console.log('Left Bumper');
        keepTrackApi.getPlugin(SelectSatManager)?.selectPrevSat();
    }
    btnRightBumper_() {
        if (settingsManager.isLimitedGamepadControls) {
            return;
        }
        console.log('Right Bumper');
        keepTrackApi.getPlugin(SelectSatManager)?.selectNextSat();
    }
    btnHome_() {
        if (settingsManager.isLimitedGamepadControls) {
            return;
        }
        console.log('Home');
        keepTrackApi.getMainCamera().state.isPanReset = true;
        keepTrackApi.getMainCamera().state.isLocalRotateReset = true;
        keepTrackApi.getMainCamera().state.ftsRotateReset = true;
    }
    btnXbox() {
        console.log('Xbox Button');
    }
    btnStart_() {
        console.log('Start');
    }
    btnLeftStick_() {
        console.log('Left Stick');
    }
    btnRightStick_() {
        console.log('Right Stick');
    }
    btnDpadUp_() {
        console.log('D-Pad Up');
        settingsManager.isAutoRotateD = false;
        settingsManager.isAutoRotateU = !settingsManager.isAutoRotateU;
        keepTrackApi.getMainCamera().autoRotate(true);
    }
    btnDpadDown_() {
        console.log('D-Pad Down');
        settingsManager.isAutoRotateU = false;
        settingsManager.isAutoRotateD = !settingsManager.isAutoRotateD;
        keepTrackApi.getMainCamera().autoRotate(true);
    }
    btnDpadLeft_() {
        console.log('D-Pad Left');
        settingsManager.isAutoRotateR = false;
        settingsManager.isAutoRotateL = !settingsManager.isAutoRotateL;
        keepTrackApi.getMainCamera().autoRotate(true);
    }
    btnDpadRight_() {
        console.log('Right');
        settingsManager.isAutoRotateL = false;
        settingsManager.isAutoRotateR = !settingsManager.isAutoRotateR;
        keepTrackApi.getMainCamera().autoRotate(true);
    }
    updateZoom_() {
        if (!this.currentController) {
            return;
        }
        const zoomOut = this.currentController.buttons[6].value;
        const zoomIn = this.currentController.buttons[7].value;
        if (zoomOut === 0 && zoomIn === 0) {
            return;
        } // Not Zooming
        const renderer = keepTrackApi.getRenderer();
        let zoomTarget = keepTrackApi.getMainCamera().zoomLevel();
        switch (keepTrackApi.getMainCamera().cameraType) {
            case CameraType.FIXED_TO_EARTH:
            case CameraType.FIXED_TO_SAT:
                zoomTarget += (zoomOut / 500) * renderer.dt;
                zoomTarget -= (zoomIn / 500) * renderer.dt;
                keepTrackApi.getMainCamera().state.zoomTarget = zoomTarget;
                keepTrackApi.getMainCamera().state.camZoomSnappedOnSat = false;
                keepTrackApi.getMainCamera().state.isAutoPitchYawToTarget = false;
                if (zoomTarget < keepTrackApi.getMainCamera().zoomLevel()) {
                    keepTrackApi.getMainCamera().state.isZoomIn = true;
                }
                else {
                    keepTrackApi.getMainCamera().state.isZoomIn = false;
                }
                break;
            case CameraType.FPS:
            case CameraType.SATELLITE:
            case CameraType.PLANETARIUM:
            case CameraType.ASTRONOMY:
                if (zoomOut !== 0) {
                    keepTrackApi.getMainCamera().state.fpsVertSpeed += (zoomOut * 2) ** 3 * renderer.dt * settingsManager.cameraMovementSpeed;
                }
                if (zoomIn !== 0) {
                    keepTrackApi.getMainCamera().state.fpsVertSpeed -= (zoomIn * 2) ** 3 * renderer.dt * settingsManager.cameraMovementSpeed;
                }
                break;
            default:
                // Do nothing
                break;
        }
    }
    updateLeftStick_() {
        if (!this.currentController) {
            return;
        }
        const x = this.currentController.axes[0];
        const y = this.currentController.axes[1];
        if (x > this.deadzone || x < -this.deadzone || y > this.deadzone || y < -this.deadzone) {
            keepTrackApi.getMainCamera().autoRotate(false);
            const drawManagerInstance = keepTrackApi.getRenderer();
            settingsManager.lastGamepadMovement = Date.now();
            switch (keepTrackApi.getMainCamera().cameraType) {
                case CameraType.FIXED_TO_EARTH:
                case CameraType.FIXED_TO_SAT:
                    keepTrackApi.getMainCamera().state.camAngleSnappedOnSat = false;
                    keepTrackApi.getMainCamera().state.isAutoPitchYawToTarget = false;
                    keepTrackApi.getMainCamera().state.camPitchSpeed -= (y ** 3 / 200) * drawManagerInstance.dt * settingsManager.cameraMovementSpeed;
                    keepTrackApi.getMainCamera().state.camYawSpeed += (x ** 3 / 200) * drawManagerInstance.dt * settingsManager.cameraMovementSpeed;
                    break;
                case CameraType.FPS:
                case CameraType.SATELLITE:
                case CameraType.PLANETARIUM:
                case CameraType.ASTRONOMY:
                    if (y > this.deadzone || y < -this.deadzone) {
                        keepTrackApi.getMainCamera().state.fpsForwardSpeed = -(y ** 3) * drawManagerInstance.dt;
                    }
                    if (x > this.deadzone || x < -this.deadzone) {
                        keepTrackApi.getMainCamera().state.fpsSideSpeed = x ** 3 * drawManagerInstance.dt;
                    }
                    break;
                default:
                    // Do nothing
                    break;
            }
        }
    }
    updateRightStick_() {
        if (settingsManager.isLimitedGamepadControls || !this.currentController) {
            return;
        }
        const x = this.currentController.axes[2];
        const y = this.currentController.axes[3];
        const drawManagerInstance = keepTrackApi.getRenderer();
        keepTrackApi.getMainCamera().state.isLocalRotateOverride = false;
        if (y > this.deadzone || y < -this.deadzone || x > this.deadzone || x < -this.deadzone) {
            keepTrackApi.getMainCamera().autoRotate(false);
            switch (keepTrackApi.getMainCamera().cameraType) {
                case CameraType.FIXED_TO_EARTH:
                case CameraType.FIXED_TO_SAT:
                    keepTrackApi.getMainCamera().state.isLocalRotateOverride = true;
                    keepTrackApi.getMainCamera().state.localRotateDif.pitch = (-y * 200);
                    keepTrackApi.getMainCamera().state.localRotateDif.yaw = (-x * 200);
                    break;
                case CameraType.FPS:
                case CameraType.SATELLITE:
                case CameraType.PLANETARIUM:
                case CameraType.ASTRONOMY:
                    keepTrackApi.getMainCamera().state.camPitchSpeed += (y / 100) * drawManagerInstance.dt * settingsManager.cameraMovementSpeed;
                    keepTrackApi.getMainCamera().state.camYawSpeed -= (x / 100) * drawManagerInstance.dt * settingsManager.cameraMovementSpeed;
                    break;
                default:
                    // Do nothing
                    break;
            }
        }
    }
    vibrate(vibrateTime) {
        if (!this.currentController) {
            return;
        }
        this.currentController.vibrationActuator.playEffect('dual-rumble', {
            duration: vibrateTime ?? 300,
            strongMagnitude: 1.0,
            weakMagnitude: 1.0,
            startDelay: 0,
        });
    }
    static getController(index = 0) {
        // If gamepad not specified then try the first one
        const gamepads = navigator.getGamepads().filter((gamepad) => gamepad !== null);
        if (gamepads.length > index && gamepads[index] !== null) {
            return gamepads[index];
        }
        // Get the gamepad or return null if not connected
        return null;
    }
}
